import { render, staticRenderFns } from "./index.vue?vue&type=template&id=45e7618d&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=45e7618d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45e7618d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/site-front-pipline/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('45e7618d')) {
      api.createRecord('45e7618d', component.options)
    } else {
      api.reload('45e7618d', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=45e7618d&scoped=true&", function () {
      api.rerender('45e7618d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/workplace/manager/index.vue"
export default component.exports